'use client';
import * as React from 'react';

import { SubmitButton } from '../../../ui/shared';
import { useStudySessionStore } from '../../stores/study-session-store';

interface ProfileFormProps {
  buttonText: string;
  disabled: boolean;
}

const FormActionButton: React.FC<ProfileFormProps> = ({ buttonText, disabled }) => {
  const { isLoading } = useStudySessionStore();
  return <SubmitButton buttonText={buttonText} isLoading={isLoading} isDisabled={disabled} />;
};

export default FormActionButton;
